module.exports = __webpack_public_path__ + "images/saaremaa/routes/pointers/LAA-PII-LAA.png";